// extracted by mini-css-extract-plugin
module.exports = {"bounds":"Content_bounds___dXZX","header":"Content_header__3M56d","headerFont":"Content_headerFont__3-PV9","lockMessage":"Content_lockMessage__6Lpw3"};